import React from 'react';
import { useContext as useUsersContext } from 'components/Users/Context';

import IconWithText from 'components/Widgets/IconWithText';

export default function Cost() {
  const { state: userState } = useUsersContext();

  return (
    <IconWithText
      iconClassName="coins-icon bg-gray-800"
      iconBg="bg-gray-100"
      wrapperClassName="mb-4"
    >
      <>
        <div className="small text-gray-800">
          Cost
        </div>

        <div className="fw-semibold text-gray-900">
          1 Credit
          {userState?.user && userState.user.attributes.specific.credit_available > 0 && (
          <>
            {' | '}
            {userState?.user && userState.user.attributes.specific.credit_available}
            {' '}
            credits available
          </>
          )}
        </div>
      </>
    </IconWithText>
  );
}
